import TProfileEditUserInfo from './index.vue';

TProfileEditUserInfo.install = app => {
  app.component(TProfileEditUserInfo.name, TProfileEditUserInfo);
};

export default TProfileEditUserInfo;
